import BaseApi from '../base/apiBase.service';

export default class CertificationService extends BaseApi {
  constructor(args) {
    super(args);

    this.serviceEndpoints = {
      baseUrl: process.env.REACT_APP_BACKEND_URL,
      get: '/api/certification/',
      create: '/api/certification',
      update: '/api/certification',
      delete: '/api/certification',
      getMyCertifications: '/api/certification/my-certifications',
    };
  }
  async getByParameters(data) {
    return super.getByParameters(data);
  }

  async update(data) {
    return super.update(data);
  }

  async create(data) {
    return super.create(data);
  }

  async delete(data) {
    return super.delete(data);
  }

  async get(payload) {
    return super.get(payload, this.serviceEndpoints.get);
  }

  async getMyCertifications(payload, uri) {
    return super.get(payload, this.serviceEndpoints.getMyCertifications);
  }
}
